import { render, staticRenderFns } from "./SrNoticePop.vue?vue&type=template&id=70acd33c"
import script from "./SrNoticePop.vue?vue&type=script&lang=js"
export * from "./SrNoticePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70acd33c')) {
      api.createRecord('70acd33c', component.options)
    } else {
      api.reload('70acd33c', component.options)
    }
    module.hot.accept("./SrNoticePop.vue?vue&type=template&id=70acd33c", function () {
      api.rerender('70acd33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SrNoticePop.vue"
export default component.exports